import { Language } from './common';
import { Chapter } from './chapter';
import { User } from './user.model';

export class Course {
  _id: string;
  title: string;
  brief: string;
  description: string;
  category: string;
  level: string;
  courseLength: number;
  whatYouWillLearn: string;
  whoThisCourseIsFor: string;
  imgUrl: string;
  language: string = Language.Kyrgyz;
  instructor: User;
  price = 0;
  views = 0;
  enrolled = 0;
  chapters: Chapter[] = [];
  createdAt: Date;
  updatedAt: Date;
}
